/* DVR - A MINIATURA DA GAVETA E A FOTO DA PECA, NAO A ARTE. (Claude, 06/10/2026)

   O QUE ACONTECIA. Agora que as 160 pecas tem foto por cor e por local, a
   gaveta mostra a camiseta certa no instante em que o item e adicionado. Mas
   bastava dar F5, ou fechar e abrir a gaveta, para a miniatura voltar a ser a
   ARTE solta, perdendo a cor e o local que a pessoa escolheu.

   POR QUE. Existem dois pintores da mesma linha. O snippet
   dvr-carrinho-modelagem.liquid e a fonte unica desde 25/09: ele monta o texto
   e, desde 04/10, troca a arte pela foto quando a linha ja tem foto. O
   vf-molde.js carrega uma copia antiga dessa rotina (pintaCarrinho) que roda SO
   na pagina de produto e que forca a arte sem perguntar: poe a classe vfm-mini
   na caixa, vfm-arte-mini na imagem e grava o endereco da propriedade _Arte por
   cima da foto. Conferido no DOM: a caixa ficava com as duas marcas ao mesmo
   tempo, dvr-foto (o snippet acertou) e vfm-mini (o vf-molde desfez depois).

   Na maior parte do tempo o vf-molde se contem, porque so repinta quando
   window.dvrPinta() devolve falso. O furo e uma chamada incondicional: dentro
   de ligaCarrinho() ele dispara pegaCarrinho() uma vez por carregamento de
   pagina. E dai que vem a arte de volta no F5 e ao reabrir a gaveta.

   O CONSERTO. O proprio ligaCarrinho() comeca com uma trava: se o elemento
   #CartDrawer-Dynamic-Wrapper ja tiver dataset.vfmLig, ele devolve na hora e
   nao engancha nada. Este arquivo so carimba essa trava assim que o elemento
   nasce, antes de o vf-molde chegar nele. A copia antiga fica dormindo e a
   gaveta passa a ter um dono so, o snippet, que ja cuida do texto E da imagem
   em TODA pagina, nao apenas na de produto.

   Nenhum motor foi reescrito: o vf-molde continua inteiro, so nao engancha mais
   no carrinho. Apagar a linha que chama este arquivo em snippets/scripts.liquid
   devolve tudo ao que era.
*/
(function () {
'use strict';

function trava() {
  var w = document.getElementById('CartDrawer-Dynamic-Wrapper');
  if (!w) return;
  if (!w.dataset.vfmLig) w.dataset.vfmLig = '1';
}

trava();

/* a gaveta e desenhada por JavaScript e pode ser recriada, entao o carimbo e
   refeito. o observador e so de childList e o carimbo e um atributo: nao ha
   como se realimentar. */
if (window.MutationObserver) {
  new MutationObserver(trava).observe(document.documentElement, { subtree: true, childList: true });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', trava);
else trava();
window.addEventListener('load', trava);
})();
